__turbopack_context__.v({
  "compact": "N4u-8W_compact",
  "full": "N4u-8W_full",
});
